import React, {
  PropTypes,
  Component
} from 'react';
import {
  connectToStores
} from 'fluxible/addons';
import {
  setpopularsearch
} from '../actions/HomeLoadCreator';
import {
  storeUserSelectedEntity,
  loadAutoComplete
} from '../actions/WebsiteLoadCreator';

class UserSelection extends Component {

  static propTypes = {
    entities: PropTypes.object.isRequired
  }

  static defaultProps = {
    entities: {}
  }

  static contextTypes = {
    executeAction: React.PropTypes.func
  }
  componentDidMount() {
    $("span[class*='popularTopicEntity']").click(function(e) {
      $('#tags').val($(e.target).text().trim());
      $('#tags').focus();
    });
    $('input.filter-checkbox').on('change', function() {
      $('input.filter-checkbox').not(this).prop('checked', false);
    });
  }
  render() {
    var availableTags = [];
    var favResult = [];
    var autocompletedata = this.props.autocompletedata;
    return (
      <div id="fade">
        <div className="black_overlay">
        </div>
        <div className="white_content">
          <img className="close-btn" style={ { "width": "2.5em", "height": "2.5em","display":"none" } } id="searchbox" onClick={ this.searchbox.bind(this) } src="https://k-s3bkp.s3.eu-west-2.amazonaws.com/folink/icons/Cross.png"
          />
          <div style={ { "margin-top": "2%", "position": "relative" } }>
            { this.props.logindata.logged_in === 0 && (
              <div className="board-title">
                Welcome on board,
              </div>
              ) }
            { this.props.logindata.logged_in === 1 && (
              <div className="board-title">
                Welcome on board,
                { this.props.logindata.username }!
              </div>
              ) }
            <div className="board-title">Give us 3 restaurants you like</div>
          </div>
          <div>
            <div className="ui-widget search-box" style={ { "width": "55%", "background-color": "rgba(0, 0, 0, 0.1)", "padding-bottom": "2vh", "padding-top": "0vh" } }>
              <input type="text" className="search-box-bar ui-autocomplete-input" id="tags" onFocus={ this.autocomplete.bind(this, availableTags) } placeholder="Search Restaurants ..." required="" />
              <a className='search-anchor-icon' onClick={ this.search.bind(this) }><i className="sprite-white sprite-Search" style={ { "zoom": "1.5", "margin-right": "0" } }></i></a>
            </div>
            <div className="fav-container">
              <div className="fav-box" id="box1" style={{"margin-left":"5%"}}>
                <div>1</div>
              </div>
              <div className="fav-box" id="box2">
                <div>2</div>
              </div>
              <div className="fav-box" id="box3">
                <div>3</div>
              </div>
            </div>
            <div className="search-filters">
            </div>
            <div className='Error-msg'> Please select 3 restaurants</div>
            <div className="submit-btn" onClick={ this.SubmitPage.bind(this) }>
              <div style={ { "display": "table-cell", "vertical-align": "middle" } }>
                Done <img className="submit-icon" src="https://folink.s3.eu-west-2.amazonaws.com/icons/arrow1.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  userfavourite() {
    $('#fade').css('display', 'block');
  }
  searchbox() {
    $('#fade').css('display', 'none');
    $('.search-container').css('display', 'block');
    $('#box1').html("<div style='padding: 0.5em'>1</div>");
    $('#box2').html("<div style='padding: 0.5em'>2</div>");
    $('#box3').html("<div style='padding: 0.5em;'>3</div>");
  }
  SubmitPage(favResult) {
    /*if (($('#box1').html() != 1) && ($('#box2').html() != 2) && ($('#box3').html() != 3)) {
      var entity = {};
      entity.result = [];
      for (var i = 1; i < 4; i++) {
        var object = {};
        object.title = $('#box' + i).find('.fav-entitytext').text();
        object.id = $('#box' + i).find('.text' + i + '').attr('id');
        object.imageLink = $('#box' + i).find('.website-image').attr('src');
        entity.result.push(object);
      }
      var ids = {};
      ids.first = entity.result[0].id.split('/')[1];
      ids.second = entity.result[1].id.split('/')[1];
      ids.third = entity.result[2].id.split('/')[1];
      var filters = [];
      $('.search-filter-form input[type="checkbox"]').each(function(i, obj) {
        if ($(obj).prop('checked')) {
          filters.push($(obj).val());
        }
      });
      var response = {};
      response.ids = [ids.first, ids.second, ids.third, filters[0]];
      this.context.executeAction(storeUserSelectedEntity, response);
      location.href = '/userfavourite/' + ids.first + ',' + ids.second + ',' + ids.third + ',' + filters;
    } else {
      $('.Error-msg').css('opacity', '1');
    }*/
if (($('#box1').text() != 1) && ($('#box2').text() != 2) && ($('#box3').text() != 3)) {
      var entity = {};
      var url = '';
      entity.result = [];
      for (var i = 1; i < 4; i++) {
	if($('#box' + i).find('.fav-entitytext').text() != ''){
        	var object = {};
	        object.title = $('#box' + i).find('.fav-entitytext').text();
        	object.id = $('#box' + i).find('.text' + i + '').attr('id');
	        object.imageLink = $('#box' + i).find('.website-image').attr('src');
        	entity.result.push(object);
	}
      }
     var response = {"ids":[]};
   //  var response.ids= [];
     var filters = [];
       $('.search-filter-form input[type="checkbox"]').each(function(i, obj) {
        if ($(obj).prop('checked')) {
          filters.push($(obj).val());
        }
      });
     for (var i = 0; i<entity.result.length;i++){
        var id = entity.result[i].id.split('/')[1];
        response.ids.push(id)
        url += id + ',';
        }
      response.ids.push(filters[0]); 
      /*var ids = {};
      ids.first = entity.result[0].id.split('/')[1];
      var filters = [];
      if (entity.result[1].title == undefined)
	ids.second = ''
      else
      	ids.second = entity.result[1] || entity.result[1].id.split('/')[1];
      if (entity.result[2].title == undefined)
	ids.third = ''
      else
      	ids.third = entity.result[2] || entity.result[2].id.split('/')[1];
      var filters = [];
      $('.search-filter-form input[type="checkbox"]').each(function(i, obj) {
        if ($(obj).prop('checked')) {
          filters.push($(obj).val());
        }
      });
      var response = {};
      if(ids.second == '' && ids.third == ''){
      	response.ids = [ids.first, filters[0]];
	url = ids.first
	}
      else if(ids.third == ''){
	response.ids = [ids.first,ids.second, filters[0]]
	url = ids.first + ',' + ids.second
	}
      else{
		response.ids = [ids.first, ids.second, ids.third, filters[0]];
	url = ids.first + ',' + ids.second + ',' + ids.third
	}*/
      this.context.executeAction(storeUserSelectedEntity, response);
      if(location.href.lastIndexOf('/') == location.href.length - 1) {
        location.href += 'userfavourite/' + url.replace(/(^\s*,)|(,\s*$)/g, '') ;
      } else
      location.href += '/userfavourite/' + url.replace(/(^\s*,)|(,\s*$)/g, '') ;
    } else {
      $('.Error-msg').css('opacity', '1');
    }

  }
  search() {
    $("#tags").autocomplete('search');
  }
  autocomplete(availableTags, favResult) {
    function removeEntities(data) {
      var ind = availableTags.indexOf(data);
      availableTags.splice(ind, 1);
    }
    $("#tags").autocomplete({
        minLength: 1,
        autoFocus: true,
        source: function(request, response) {
          this.context.executeAction(loadAutoComplete, {
            query: request.term.toLowerCase()
          });
          setTimeout(function() {
            var results = this.props.autocompletedata.results;
            response(results.filter(x => !availableTags.includes(x.title)).map(x => {
              return {
                label: x.title,
                the_link: "service/" + x.id,
                value: x.title,
                image_url: x.image_url,
                desc: x.address
              };
            }));
          }.bind(this), 700);
        }.bind(this),

        open: function() {
          $("ul.ui-menu").width($(this).innerWidth());
          if ($('ul.ui-autocomplete li:first').attr('class') === 'totalcount') {
            $('ul.ui-autocomplete li:first').remove();
          } else {
            $('ul.ui-autocomplete').prepend('<li class="totalcount"></li>');
            var len = $('.ui-menu > li').length;
            $('.totalcount').html('' + len - 1 + ' matching results');
          }

        },
        select: function(event, ui) {
          this.context.executeAction(setpopularsearch, {
            word: ui.item.value,
            link: ui.item.the_link
          });
          var image = document.createElement("img");
          image.src = ui.item.image_url;
          image.setAttribute('class', 'website-image box-border');
          availableTags.push(ui.item.value);
          var Box1Entity;
          var Box2Entity;
          var Box3Entity;
          if ($('#box1').find('img').length === 0) {
            Box1Entity = ui.item;
            $('#box1').html(image);
            $('#box1').prepend("<div class='fav-entitytext'><div class='text1 fav-text'></div><img class='close-btn' id='btn1' src='https://folink.s3.eu-west-2.amazonaws.com/icons/cross.png' /></div>");
            favResult[0] = new myElement(ui.item.the_link, ui.item.value, ui.item.image_url);
            $('.text1').html(ui.item.value);
            $('.text1').attr('id', ui.item.the_link);
          } else if ($('#box2').find('img').length === 0) {
            Box2Entity = ui.item;
            $('#box2').html(image);
            $('#box2').prepend("<div class='fav-entitytext'><div class='text2 fav-text'></div><img class='close-btn' id='btn2' src='https://folink.s3.eu-west-2.amazonaws.com/icons/cross.png' /></div>");
            favResult[1] = new myElement(ui.item.the_link, ui.item.value, ui.item.image_url);
            $('.text2').html(ui.item.value);
            $('.text2').attr('id', ui.item.the_link);
          } else if ($('#box3').find('img').length === 0) {
            Box3Entity = ui.item;
            $('#box3').html(image);
            $('#box3').prepend("<div class='fav-entitytext'><div class='text3 fav-text'></div><img class='close-btn' id='btn3' src='https://folink.s3.eu-west-2.amazonaws.com/icons/cross.png' /></div>");
            favResult[2] = new myElement(ui.item.the_link, ui.item.value, ui.item.image_url);
            $('.text3').html(ui.item.value);
            $('.text3').attr('id', ui.item.the_link);
          }


          function myElement(id, title, image_url) {
            this.id = id,
              this.title = title,
              this.image_url = image_url
          }
          $('#btn1').click(function() {
            var removedEntites = {};
            removedEntites.the_link = $('.text1').attr('id')
            removedEntites.value = $('.text1').html();
            removedEntites.label = $('.text1').html();
            removedEntites.image_url = $('#box1').find('.website-image').attr('src');
            removedEntites.desc = Box1Entity.desc;
            removeEntities(removedEntites.value);
            $('#box1').html(1);

          });
          $('#btn2').click(function() {
            var removedEntites = {};
            removedEntites.the_link = $('.text2').attr('id')
            removedEntites.value = $('.text2').html();
            removedEntites.label = $('.text2').html();
            removedEntites.image_url = $('#box2').find('.website-image').attr('src');
            removedEntites.desc = Box2Entity.desc;
            removeEntities(removedEntites.value);
            $('#box2').html(2);

          });
          $('#btn3').click(function() {
            var removedEntites = {};
            removedEntites.the_link = $('.text3').attr('id')
            removedEntites.value = $('.text3').html();
            removedEntites.label = $('.text3').html();
            removedEntites.image_url = $('#box3').find('.website-image').attr('src');
            removedEntites.desc = Box3Entity.desc;
            removeEntities(removedEntites.value);
            $('#box3').html(3);
            return false;
          });
          $('.search-box-bar').val("");
          $('.count').html('');
          return false;
        }.bind(this),
      })
      .data("ui-autocomplete")._renderItem = function(ul, item) {
        return $("<li>")
          .append("<a>" + item.label + '<br><span class="autoCompleteDesc">' + item.desc + "</span></a>")
          .appendTo(ul);
      };
  }
}
UserSelection.defaultProps = {
  logindata: {},
  autocompletedata: []
};

UserSelection = connectToStores(UserSelection, ['LoginStore', 'AutoCompleteStore'], (stores, props) => {
  return {
    logindata: stores.LoginStore.get(),
    autocompletedata: stores.AutoCompleteStore.get()
  };

});

module.exports = UserSelection;



// WEBPACK FOOTER //
// ./src/components/UserSelection.js